<template>
    <div class="dashboard-page bold tablec">
        <div class="d-flex flex-row">
        <Widget class="shares-widget w-100 bg-transparent">
            <h4>Manage behaviour badges</h4>
            <Loader v-if="isReceiving" :size="40"></Loader>
            <div class="form-group mt-4">
                <label for="badgeAction">Select badge</label>
                <v-select :clearable="false"
                          class="w-25"
                          id="badgeAction"
                          :options="availableBadges"
                          @input="onBadgeSelect"
                />
            </div>
            <div class="list-group list-group-lg">
                <div href="#" style="align-items: center" class="list-group-item display-flex" v-for="badge in badges" :key="badge.id" >
                                <span class="thumb-xl mr" style="width: 100px">
                                  <img :src="badge.downloadUrl" alt="..." />
                                </span>
                    <div style="width:70%">
                        <h4 class="">
                            <i class="fa fa-circle" :class="'text-' + (badge.public ? 'success' : 'inverse')"></i>
                            {{badge.title}}
                        </h4>
                        <h6>{{badge.description}}</h6>
                    </div>
                    <div class="ml-auto">
                        <span :id="'popoverDeleteManageBadge_' + badge.id"
                              class="glyphicon glyphicon-remove icon-button"/>
                        <b-popover class="popover-danger"
                                   triggers="click"
                                   :target="'popoverDeleteManageBadge_' + badge.id"
                                   :show.sync="badgePopover[badge.id]"
                                   placement="top">
                            <template slot="title">
                                <div class="px-5">Are you sure you want to remove this badge?</div>
                            </template>
                            <div class="px-5 d-flex justify-content-center">
                                <b-button-toolbar>
                                    <b-button variant="success" size="xs"
                                              @click="removeBadge(badge)">
                                        Yes
                                    </b-button>
                                    <b-button variant="danger" size="xs"
                                              @click="closePopover(badge.id)">
                                        No
                                    </b-button>
                                </b-button-toolbar>
                            </div>
                        </b-popover>
                    </div>
                </div>
            </div>
            <div>

                <b-button-toolbar>
                    <b-button variant="success"
                              @click="saveBadgesForBehaviour()">
                        <Loader v-if="isUpdating"></Loader>
                        <span v-else>Save</span>
                    </b-button>

                    <b-button variant="default" @click="goBack()">
                        Back
                    </b-button>
                </b-button-toolbar>
            </div>
        </Widget>
        </div>
    </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import DatePicker from 'vue2-datepicker';
  import Vue from "vue";
  import moment from 'moment';
  import Loader from '../../components/Loader/Loader';
  import {firestore} from "../../main";
  import vSelect from "vue-select";

  export default {
    name: "ManageBadges",
    components: { DatePicker, Loader, vSelect },
    data() {
      return {
        popover: false,
        badgePopover: {},
        badges: [],
        errorsList: [],
        availableBadges: []
      }
    },
    async mounted() {
      await this.getBadgesForBehaviour(this.getId())
      this.badges = [...this.selectedBehaviourBadges];

      if(this.selectedCountry && this.behaviour) {
        const globalBadgesSnapshot = await firestore.collection('badges')
          .where("public", "==", true)
          .where("global", "==", true).get()
        const snapshot = await firestore.collection('badges')
          .where("public", "==", true)
          .where("tenantId", "==", this.selectedCountry.id).get()
        this.availableBadges = globalBadgesSnapshot.docs.map(doc => Object.assign ({} , doc.data(),
          {id: doc.id, label:doc.data().title}));
        if(!this.behaviour.global){
          snapshot.docs.forEach(doc => this.availableBadges.push(Object.assign ({} , doc.data(),
            {id: doc.id, label:doc.data().title})));
        }
        this.selectedBadgeIds = this.badges.map(b => b.id)

        this.availableBadges = this.availableBadges.filter(b => !this.selectedBadgeIds.includes(b.id) )
      }
    },
    computed: {
      ...mapState("behaviours", ["behaviours", "selectedBehaviourBadges", "isReceiving", "isUpdating", "isDeleting"]),
      ...mapState("countries", ["selectedCountry"]),
      ...mapState("auth", ["currentUser"]),
      behaviour() {
        return this.findBehaviour(this.getId()) || {}
      }
    },

    methods: {
      ...mapActions("auth", ["fetchCurrentUser"]),
      ...mapActions("behaviours", ["getBehavioursRequest", "getBadgesForBehaviour", "saveBadgesForBehaviourRequest"]),
      onSubmit(e) {
        // e.preventDefault();
        // !this.isNew() ? this.updateUserRequest({this.user, $toasted}) : this.createUserRequest({this.user, $toaster})
      },
      goBack() {
        this.$router.replace('/app/content/behaviours');
      },
      onBadgeSelect(badge){
        this.badges.push(badge);
        this.availableBadges = this.availableBadges.filter(b => b.id != badge.id)
      },
      removeBadge(badge){
        this.badges = this.badges.filter(b=> b.id != badge.id);
        this.availableBadges.push(Object.assign({}, badge, {label: badge.title}))
        this.badgePopover[badge.id] = false;
      },
      saveBadgesForBehaviour(){
        const selectedBadgeIds = this.badges.map(b => b.id)
        const behaviourId = this.getId();
        this.saveBadgesForBehaviourRequest({behaviourId: behaviourId, badgesIds: selectedBadgeIds, $toasted: this.$toasted})

      },
      findBehaviour(id) {
        let behaviour = this.behaviours && this.behaviours.length > 0 ? this.behaviours.find(b => b.id === id) : null
        if(behaviour != null){
          this.startDate = moment.unix(behaviour.startDate['seconds']).format('DD/MM/YYYY')
          this.endDate = moment.unix(behaviour.endDate['seconds']).format('DD/MM/YYYY')
        }
        return behaviour;
      },
      getId() {
        return this.$route.params.id || -1;
      },
      closePopover(id) {
        this.badgePopover[id] = false;
      },
    }
  }
</script>

<style scoped>

</style>
